import { t } from "i18next";

export type StatusProps = {
  status: "pending" | "complete" | "progress" | "retarded";
};

const statuses = {
  pending: "text-gray-600 bg-gray-50 ring-gray-500/10",
  completed: "text-green-700 bg-green-50 ring-green-600/20",
  progress: "text-yellow-800 bg-yellow-50 ring-yellow-600/20",
  retarded: "text-red-700 bg-red-50 ring-red-600/20",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Status = ({ status }: StatusProps) => {
  return (
    <p
      className={classNames(
        statuses[status],
        "mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
      )}
    >
      {t(`task.views.${status}`)}
    </p>
  );
};

export default Status;
